module.exports = __webpack_public_path__ + "media/images/md-fcc72d3168f06375300283bfbcea1ddc.png";